module.exports = __webpack_public_path__ + "static/media/sf-test-14.649b395f.mp3";